module.exports = __webpack_public_path__ + "static/media/log.9564951f.jpg";